import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

export default function ProtectedHRRoute({ element }) {
  const userId = localStorage.getItem("userId");
  const roles = localStorage.getItem("role");

  if (!userId || !roles) {
    return <Navigate to="/signIn" replace />;
  }
  return <>{element}</>;
}

ProtectedHRRoute.propTypes = {
  element: PropTypes.element.isRequired,
};
